import {user as userProperty} from 'login';

export function getCurrentUser() {
  return dispatch => {
    userProperty.onValue(domUser => {
      dispatch({ type: 'CURRENT_USER_DATA', data: domUser });
    });
  };
}



// WEBPACK FOOTER //
// ./web/js/stores/actions/user.js